<template>
  <div class="sn-f-b-s payment">
    <sn-navigator id="MZJF"></sn-navigator>
    <div class="sn-f-1 sn-f-col-b-s payment-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_MZJF)
      }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-col-s-c payment-blank">
        <div class="title">请使用微信扫码缴费</div>
        <img :src="`${ALI_CLOUD_DOMAIN_STATIC}/hos/ui/images/pc/payment/${$sn.utils.getHospitalId()}.png`">
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  mixins: [HomepageMixin],
  data() {
    return {
      ALI_CLOUD_DOMAIN_STATIC: self.$sn.constants.ALI_CLOUD_DOMAIN_STATIC
    };
  },
  created: function() {
    document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZJF);
    this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZJF);
  }
};
</script>
<style lang="scss" scoped>
.payment {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    height: 100%;

    .payment-blank {
      overflow: hidden;
      width: 100%;
      padding: 20px 20px 0;

      .title {
        @include fs(28);

        font-weight: bold;
        color: $text1;
        margin-bottom: 20px;
      }

      img {
        width: 400px;
        height: 400px;
      }
    }
  }
}
</style>
